'use client';

import { FC } from 'react';

import { PropsOf } from '@emotion/react';
import { QueryParamProvider as BaseQueryParamProvider } from 'use-query-params';
import { useIsClient } from 'usehooks-ts';

import { NextAdapter } from './NextAdapter';
import { NullAdapter } from './NullAdapter';

export const QueryParamProvider: FC<
  Omit<PropsOf<typeof BaseQueryParamProvider>, 'adapter'>
> = (props) => {
  const isClient = useIsClient();

  return (
    <BaseQueryParamProvider
      adapter={isClient ? NextAdapter : NullAdapter}
      {...props}
    />
  );
};
